import { request, METHODS, requestV3 } from '../axiosInstances';

export default {
  get: (params = {}) => requestV3(METHODS.GET, `/management/legacy/`, { params }),
  getCount: (params = {}) => requestV3(METHODS.GET, `/management/legacy/count/`, { params }),
  getProgress: (id: number, params = {}) => request(METHODS.GET, `/jobs/${id}/`, { params }),
};
